<template>
  <v-select
    :value="value"
    :items="computedItems"
    :loading="loading"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    multiple
    chips
    small-chips
    return-object
    persistent-hint
    :disabled="disabled"
    :rules="rules"
    @input="onInput"
  >
    <!-- Custom item rendering for Select All -->
    <template v-slot:item="{ item }">
      <v-list-item
        @click="onItemClick(item)"
      >
        <v-list-item-action>
          <v-checkbox
            :input-value="isItemSelected(item)"
            :ripple="false"
          />
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            {{ item[itemText] }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Chips rendering -->
    <template v-slot:selection="{ item, index }">
      <v-chip
        v-if="index < visibleChips"
        small
        class="mr-1"
      >
        {{ item[itemText] }}
      </v-chip>

      <v-chip
        v-else-if="index === visibleChips && value.length > visibleChips"
        small
        class="mr-1"
      >
        +{{ value.length - visibleChips }} others
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "MultiSelectDropdown",

  props: {
    value: {
      type: Array,
      default: () => []
    },

    items: {
      type: Array,
      required: true
    },

    loading: Boolean,
    label: String,

    itemText: {
      type: String,
      default: "text"
    },

    itemValue: {
      type: String,
      default: "value"
    },

    visibleChips: {
      type: Number,
      default: 3
    },

    disabled: Boolean,

    rules: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    selectAllOption() {
      return {
        [this.itemText]: "Select All",
        [this.itemValue]: "__SELECT_ALL__",
        isSelectAll: true
      };
    },

    computedItems() {
      return [this.selectAllOption, ...this.items];
    },

    allSelected() {
      return (
        this.items.length > 0 &&
        this.value.length === this.items.length
      );
    }
  },

  methods: {
    isItemSelected(item) {
      if (item.isSelectAll) {
        return this.allSelected;
      }

      return this.value.some(
        v => v[this.itemValue] === item[this.itemValue]
      );
    },

    onItemClick(item) {
      if (item.isSelectAll) {
        this.toggleSelectAll();
        return;
      }

      this.toggleItem(item);
    },

    toggleSelectAll() {
      if (this.allSelected) {
        this.emitValue([]);
      } else {
        this.emitValue([...this.items]);
      }
    },

    toggleItem(item) {
      const exists = this.value.some(
        v => v[this.itemValue] === item[this.itemValue]
      );

      let updated;

      if (exists) {
        updated = this.value.filter(
          v => v[this.itemValue] !== item[this.itemValue]
        );
      } else {
        updated = [...this.value, item];
      }

      this.emitValue(updated);
    },

    onInput(val) {
      // Prevent Vuetify default behavior
      // All selection is controlled manually
    },

    emitValue(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    }
  }
};
</script>
